import axios from "axios";

//export const API_BASE_URL = process.env.API_BASE_URL || 'https://defmal-execplatform.lhs.loria.fr';
export const REALM = process.env.REALM || 'defmal';
export const API_BASE_URL = process.env.API_BASE_URL || 'https://defmal-ecosystem.lhs.loria.fr';

//export const CLIENT = process.env.CLIENT || 'platform-portal-prod' // PROD
//export const REDIRECT_URL = process.env.REDIRECT_URL || 'https://???.lhs.loria.fr/'; // PROD

export const CLIENT = process.env.CLIENT || 'platform-portal' // DEV
export const REDIRECT_URL = process.env.REDIRECT_URL || 'https://darkweb-dumps.com'; // DEV
//export const REDIRECT_URL = process.env.REDIRECT_URL || 'http://localhost:3000'; // DEV

export const AUTH_URL = process.env.AUTH_URL || 'https://defmal-auth.lhs.loria.fr/auth';
export const USERINFOS_URL = `${AUTH_URL}/realms/${REALM}/protocol/openid-connect/userinfo`;


export const get_user_infos = async (token) => {
    try {
        const response = await fetch(USERINFOS_URL, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();

        return data; // Retourne les données une fois qu'elles sont prêtes
    } catch (error) {
        console.error('Error fetching account data:', error);
        throw error; // Relance l'erreur pour la gestion d'erreur en amont
    }
};

export const fetchTopicsFromApi = async (pageToLoad = 1, filters = {}, api_key) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        if (value.trim() !== "") params.append(key, value.trim());
    });
    params.append("page", pageToLoad);

    const response = await axios.get(`${API_BASE_URL}/topics?${params}`, {
        headers: {
            'X-API-Key': api_key,
            'accept': 'application/json'
        },
    });

    return response.data;
};


export const fetchLockbitMessages = async (clientId, api_key) => {
    const response = await axios.get(`${API_BASE_URL}/lockbit/${clientId}`, {
        headers: {
            'X-API-Key': api_key,
            'accept': 'application/json',
        },
    });

    return response.data; // { client, total, messages }
};

// 🔁 api.js

export const fetchBlackbastaContext = async (index, limit, api_key) => {
    const response = await axios.get(`${API_BASE_URL}/blackbasta/context`, {
        params: { index, limit },
        headers: { 'X-API-Key': api_key },
    });
    return response.data;
};

export const searchBlackbastaMessages = async (keyword, api_key) => {
    const response = await axios.get(`${API_BASE_URL}/blackbasta/search`, {
        params: { keyword },
        headers: { 'X-API-Key': api_key },
    });
    return response.data;
};
